import { useDispatch, useSelector } from 'react-redux';

import Organizations from 'redux/Organizations';

import Notifications from 'redux/Notifications';

const useOrganizations = () => {
  const dispatch = useDispatch();

  const isFetchingOrganizations = useSelector(Organizations.getIsFetchingOrganizations);

  const selectedOrganization = useSelector(Organizations.getActiveOrganization);
  const selectedOrganizationId = useSelector(Organizations.getActiveOrganizationId);

  const organizations = useSelector(Organizations.getOrganizations);

  const fetchOrganizations = () => {
    if (!isFetchingOrganizations) {
      dispatch(Organizations.startFetch());
      return dispatch(Organizations.fetchOrganizations()).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const setSelectedOrganization = (organizationId) => {
    return dispatch(Organizations.setSelectedOrganization(organizationId));
  };

  const saveOrganization = (organization) => {
    if (organization.id) {
      return dispatch(Organizations.updateOrganization(organization)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
    return dispatch(Organizations.createOrganization(organization)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  return {
    organizations,
    selectedOrganization,
    selectedOrganizationId,
    isFetchingOrganizations,
    setSelectedOrganization,
    fetchOrganizations,
    saveOrganization,
  };
};

export default useOrganizations;
